// extracted by mini-css-extract-plugin
module.exports = {"session":"footer_session__2mmGe","footer":"footer_footer__1lZIc","p":"footer_p__3_xD7"};